import { useEffect, useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import RastreamentoLink from '@/components/global/RastreamentoLink';

import { Container, BreadCrumbsWrapper, BreadcrumbsContainer } from './styles';

import { RiArrowRightSLine } from 'react-icons/ri';
import { ImArrowLeft2 } from 'react-icons/im';

const Rastreamento: React.FC = ({ children }): JSX.Element => {
  return (
    <Container>
      <BreadcrumbsMobile />
      <h1>Rastreamento</h1>
      <Breadcrumbs />
      {children}
    </Container>
  );
};

const Breadcrumbs = () => {
  const router = useRouter();

  const returnPreviousStepCPF = useCallback(() => {
    router.push('/rastreamento/encomendas?cpf=' + router.query.cpf);
  }, [router]);

  const [isCPF, setCPF] = useState(router.query.hasOwnProperty('cpf'));

  useEffect(() => {
    router.prefetch('/rastreamento');
    router.prefetch('/rastreamento/encomendas');
    router.prefetch('/rastreamento/resultado');
  }, [router]);

  useEffect(() => {
    setCPF(!!router.query.cpf);
  }, [router]);

  return (
    (router.pathname !== '/rastreamento' && (
      <BreadCrumbsWrapper>
        <BreadcrumbsContainer>
          <RastreamentoLink>Rastreamento</RastreamentoLink>
          {(!!router.query.cpf ||
            !!router.query.cnpj ||
            '/rastreamento/resultado') && <RiArrowRightSLine size={27} />}
          {(isCPF && router.pathname === '/rastreamento/resultado' && (
            <a onClick={returnPreviousStepCPF}>Notas Fiscais</a>
          )) ||
            (isCPF && <p>Notas Fiscais</p>)}
          {router.pathname === '/rastreamento/resultado' && (
            <>
              {isCPF && <RiArrowRightSLine size={27} />}
              <p>Resultado</p>
            </>
          )}
        </BreadcrumbsContainer>
      </BreadCrumbsWrapper>
    )) || <></>
  );
};

const BreadcrumbsMobile = (): JSX.Element => {
  const router = useRouter();

  const returnPreviousStep = useCallback(() => {
    if (
      router &&
      router.query &&
      router.query.cpf &&
      router.pathname === '/rastreamento/resultado'
    ) {
      return router.push('/rastreamento/encomendas?cpf=' + router.query.cpf);
    }
    return router.push('/rastreamento');
  }, [router]);

  if (router.pathname === '/rastreamento') return <></>;

  return (
    <BreadCrumbsWrapper className="mobile">
      <ImArrowLeft2 size={30} onClick={returnPreviousStep} />
    </BreadCrumbsWrapper>
  );
};

export default Rastreamento;
